import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { combineReducers } from 'redux'
import authReducer from './common/authSlice';
import garageReducer from './common/garageSlice';
import nearSpSlice from './common/nearSpSlice';
import generalReducer from './common/generalSlice';
import servicesSliceReducer from './common/servicesSlice';
import bookingSliceReducer from './common/bookingSlice'
import settingSliceReducer from './common/settingSlice';
import quoteSliceReducer from './common/bookingSlice/quoteSlice'
import requestSliceReducer from './common/bookingSlice/requestSlice'
import chatReducer from './common/chatSlice';
import paymentReducer from './common/paymentSlice';

// import { thunk } from 'redux-thunk';

const persistConfig = {
    key: 'root',
    storage,
}

const rootReducer = combineReducers({
    auth: authReducer,
    garage: garageReducer,
    nearSp: nearSpSlice,
    general: generalReducer,
    services: servicesSliceReducer,
    setting: settingSliceReducer,
    booking: bookingSliceReducer,
    quote: quoteSliceReducer, //part of booking
    requests: requestSliceReducer, //part of booking
    chats: chatReducer,
    payments: paymentReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
})

export const persistor = persistStore(store)